import React, { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import Banner from '../assets/Banner.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';
import { addToFav } from '../Functions';
import { useAlert } from '../AlertContext';

export default function Card_1({ video, playlist, list = false }) {
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [isFavorite, setIsFavorite] = useState(false);

    const checkIfFavorite = () => {
        const favorites = JSON.parse(localStorage.getItem('PK_Favorites') || '[]');
        return favorites.some((item) => item.id === video.id);
    };

    useEffect(() => {
        setIsFavorite(checkIfFavorite());
    }, [video]);

    const handleCardClick = () => {
        const user = localStorage.getItem('PK_user');
        if (!user) {
            const modal = new window.bootstrap.Modal(document.getElementById('loginModal'));
            modal.show();
        } else {
            navigate(`/video`, { state: { video, playlist } });
        }
    };

    const handleFavoriteToggle = () => {
        addToFav(video, showAlert);
        setIsFavorite(!isFavorite); // optimistically toggle
    };

    const heartStyle = {
        cursor: 'pointer',
        fill: isFavorite ? '#ff7474' : 'none',
        color: 'red' ,
    };

    if (list) {
        return (
            <div className="d-flex align-items-start video_card_list p-2 mb-2"
                style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: 'whitesmoke' }}>
                <div
                    className="me-3 video_card_image_div"
                    style={{ width: '145px', flexShrink: 0, cursor: 'pointer' }}
                    onClick={handleCardClick}>
                    <LazyLoadImage
                        src={video.imageCropped || Banner}
                        alt={video.name}
                        effect="blur"
                        className="img-fluid rounded"
                    />
                </div>

                <div className="d-flex flex-column justify-content-between w-100">
                    <div className="d-flex justify-content-between align-items-center">
                        <p className='video_card_title m-0'>{video.title}</p>
                        <Heart color='red' width={20} onClick={handleFavoriteToggle} style={heartStyle} />
                    </div>
                    <p className='video_card_description pt-1 m-0'>{video.description}</p>
                </div>
            </div>
        );
    }

    return (
        <div className='video_card'>
            <div className='video_card_image_div' onClick={handleCardClick}>
                <LazyLoadImage
                    src={video.imageCropped || Banner}
                    alt={video.name}
                    className="sidebar_channel_image"
                    effect="blur"
                />
            </div>
            <div className='d-flex flex-row align-items-center justify-content-between mt-2'>
                <p className='video_card_title m-0'>{video.title}</p>
                <Heart onClick={handleFavoriteToggle} style={heartStyle} />
            </div>
            <p className='video_card_description pt-1 mb-1'>{video.description}</p>
        </div>
    );
}
